/* eslint-disable react/destructuring-assignment */
import React from 'react';
import format from 'date-fns/format';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    {
      title: t('general.date'),
      field: 'date',
      render: (rowData) => format(new Date(rowData.date), 'dd/MM/yyyy'),
    },
    {
      title: t('general.title'),
      field: 'title',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.title}>
          {rowData.title}
        </span>
      ),
    },
    { title: t('general.type'), field: 'type' },
    {
      title: t('general.involved'),
      field: 'involved',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.involved}>
          {rowData.involved}
        </span>
      ),
    },
  ];
}
